import { Suspense, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setIsAuthenticated } from "./store/auth/slice";
import Layout from "./components/layout/layout";
import MainRoutes from "./router/main-router";
import Header from "./components/layout/header/header";
import Loader from "./components/ui/loader/loader";
import useRouteChangeReset from "./hooks/useRouteChangeReset";

const App = () => {
  const dispatch = useDispatch();
  const [isInitializing, setIsInitializing] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const adminRole = localStorage.getItem("adminRole");

    if (token && adminRole) {
      dispatch(setIsAuthenticated({ token, adminRole }));
    }

    setIsInitializing(false);
  }, [dispatch]);
  useRouteChangeReset();

  if (isInitializing) {
    return <Loader />;
  }

  return (
    <Layout>
      <Header />
      <div className="main_container">
        <Suspense fallback={<Loader />}>
          <MainRoutes />
        </Suspense>
      </div>
    </Layout>
  );
};

export default App;
